export class CodemationTelemetryAttributeNames {
  static readonly workflowId = "codemation.workflow.id";
  static readonly runId = "codemation.run.id";
  static readonly nodeId = "codemation.node.id";
  static readonly activationId = "codemation.activation.id";
  static readonly nodeType = "codemation.node.type";
  static readonly nodeRole = "codemation.node.role";
  static readonly workflowFolder = "codemation.workflow.folder";
  static readonly connectionInvocationId = "codemation.connection.invocation_id";
  static readonly toolName = "codemation.tool.name";
  static readonly traceParentRunId = "codemation.parent.run.id";
  static readonly iterationId = "codemation.iteration.id";
  static readonly iterationIndex = "codemation.iteration.index";
  static readonly parentInvocationId = "codemation.parent.invocation_id";
  static readonly mcpServerId = "mcp.server_id";
  static readonly mcpToolName = "mcp.tool_name";
  static readonly nodeExecutionStatus = "codemation.node.execution_status";
  static readonly runHaltReason = "codemation.run.halt_reason";
  static readonly hitlTaskId = "codemation.hitl.task_id";
  static readonly hitlChannel = "codemation.hitl.channel";
  static readonly hitlDecisionStatus = "codemation.hitl.decision_status";
}
